export const GET_RESALE_LIST_DATA_MFA = 'GET_RESALE_LIST_DATA_MFA';
export const GET_RESALE_LIST_DATA_NON_MFA = 'GET_RESALE_LIST_DATA_NON_MFA';

export const SET_DATA_FOR_RESALE_ASSETS = 'SET_DATA_FOR_RESALE_ASSETS';

export const GET_RESALE_ITEM_DETAILS_DATA_MFA =
  'GET_RESALE_ITEM_DETAILS_DATA_MFA';
export const GET_RESALE_ITEM_DETAILS_DATA_NON_MFA =
  'GET_RESALE_ITEM_DETAILS_DATA_NON_MFA';
export const SET_RESALE_ITEM_DETAILS_DATA = 'SET_RESALE_ITEM_DETAILS_DATA';
export const SET_RESALE_ASSET_DETAILS_LOADING =
  'SET_RESALE_ASSET_DETAILS_LOADING';
export const SET_RESALE_LOADING = 'SET_RESALE_LOADING';

export const SUBMIT_MFA_RESALE_ENQUIRY = 'SUBMIT_MFA_RESALE_ENQUIRY';

export const SET_RESALE_ENQUIRY_SUBMITTING = 'SET_RESALE_ENQUIRY_SUBMITTING';

export const SUBMIT_NON_MFA_RESALE_ENQUIRY = 'SUBMIT_NON_MFA_RESALE_ENQUIRY';

export const GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA =
  'GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA';
export const GET_PREVIOUS_RESALE_ENQUIRY_MFA =
  'GET_PREVIOUS_RESALE_ENQUIRY_MFA';
export const SET_PREVIOUS_RESALE_ENQUIRY = 'SET_PREVIOUS_RESALE_ENQUIRY';
